var _rect, _line, _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelevision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.90811,
    y: 31.0902,
    width: 24.1818,
    height: 32.1818,
    rx: 2.09091,
    transform: "rotate(-90 3.90811 31.0902)",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.99854,
    y1: 34.0909,
    x2: 30.9985,
    y2: 34.0909,
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0007,
    cy: 19.0913,
    r: 6.93337,
    stroke: "currentColor",
    strokeWidth: 1.81818
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8881 25.8754C16.1414 22.1286 16.1414 16.0539 19.8881 12.3072C20.0253 12.17 20.2478 12.17 20.385 12.3072C24.1317 16.0539 24.1317 22.1286 20.385 25.8754C20.2478 26.0126 20.0253 26.0126 19.8881 25.8754Z",
    stroke: "currentColor",
    strokeWidth: 1.81818,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5308 16.3185H26.4702",
    stroke: "currentColor",
    strokeWidth: 1.81818
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5308 21.864H26.4702",
    stroke: "currentColor",
    strokeWidth: 1.81818
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelevision);
export default __webpack_public_path__ + "static/media/Television.3db4b8b429987c1ff4f2021f9ce3498a.svg";
export { ForwardRef as ReactComponent };